import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import translate from './TranslateHOC';
import img404 from '../img/404.png';
import { HeroImage as HeroImageV2 } from '../v2/components/hero/heroImage/HeroImage';
import { Button as ButtonV2 } from '../v2/components/button/Button';
import { device } from '../v2/Theme';
import { withRouter } from 'react-router-dom';

const Live = ({ strings }) => {
  const HeroCardButton = withRouter(({ history, label, size, type, url }) => (
    <ButtonV2 label={label} size={size} type={type} link={url} />
  ));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="error-404 main">
      <HeroCardContainer>
        <HeroImageV2 image={img404} />
        <HeroCardInner>
          <HeroCardContent>
            <Error>{strings.error404}</Error>
            <Title>{strings.error404CantFindPage}</Title>
            <Description>{strings.error404Desc}</Description>
            <HeroCardCtas>
              <HeroCardButton
                label={strings.error404BrowseCategories}
                size="large"
                type="secondary"
                url={'/Categories'}
              />
              <HeroCardButton
                label={strings.error404TakeMeHome}
                size="large"
                type="primary"
                url={'/'}
              />
            </HeroCardCtas>
          </HeroCardContent>
        </HeroCardInner>
      </HeroCardContainer>
    </div>
  );
};

const HeroCardContainer = styled.div`
  ${(props) =>
    !props.auth &&
    `
    margin-top: -69px;
    
  `}
  padding-bottom: 24px;
  > div:first-of-type {
    display: none;
  }
  @media ${device.tablet} {
    top: 24px;
    margin-top: 0;
    position: relative;
    > div:first-of-type {
      display: block;
    }
  }
`;

const HeroCardInner = styled.div`
  position: relative;
  padding: 20px;
  top: 47px;
  transform: translateY(-47px);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  @media ${device.tablet} {
    flex-direction: row;
    text-align: left;
  }
  @media ${device.desktop} {
    padding: 36px 0;
    min-height: 400px;
  }
  @media ${device.widest} {
    padding: 48px 0;
  }
`;

const HeroCardContent = styled.div`
  ${(props) => props.theme.fontBook};
  margin-top: 1.5em;
  h6,
  h2,
  p {
    margin: 0;
  }
  ul {
    margin: 14px 0 12px;
  }
`;

const HeroCardCtas = styled.div`
  display: flex;
  flex-direction: column-reverse;
  margin-top: 2.1em;
  align-items: center;
  @media ${device.tablet} {
    flex-direction: row;
    align-items: left;
  }
  @media ${device.desktop} {
    margin-top: 2.8em;
  }
  div {
    width: 100%;
    @media ${device.tablet} {
      width: auto;
    }
  }
  div a {
    width: 100%;
    padding: 8px 26px;
    font-size: 14px;
    line-height: 21px;
    justify-content: center;
    @media ${device.tablet} {
      width: auto;
      padding: 14px 42px;
      justify-content: left;
      font-size: 18px;
    }
  }
  div + div {
    margin-bottom: 15px;
    @media ${device.tablet} {
      margin-bottom: 0;
      margin-left: 1em;
    }
    @media ${device.desktop} {
      margin-left: 1.4em;
    }
  }
`;

const Error = styled.h5`
  ${(props) => props.theme.font.h6};
  margin-bottom: 0.4em;
  color: ${(props) =>
    props.theme.name === 'light'
      ? props.theme.color.primaryAA
      : props.theme.color.primaryFull};
  text-shadow: 0px 0px 2px
    ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.white90
        : props.theme.color.blackFull};
  @media ${device.tablet} {
    ${(props) => props.theme.font.body.bold};
    line-height: 24px;
    letter-spacing: -0.35px;
    text-transform: uppercase;
  }
  @media ${device.desktop} {
    ${(props) => props.theme.font.h6};
    margin-bottom: 0;
  }
`;

const Title = styled.h2`
  ${(props) => props.theme.font.h5};
  padding-bottom: 6px;
  color: ${(props) =>
    props.theme.name === 'light'
      ? props.theme.color.black90
      : props.theme.color.whiteFull};
  @media ${device.tablet} {
    ${(props) => props.theme.font.h3};
  }
`;

const Description = styled.p`
  max-width: 30em;
  ${(props) => props.theme.font.subtitle.book};
  color: ${(props) =>
    props.theme.name === 'light'
      ? props.theme.color.black50
      : props.theme.color.white90} !important;
  @media ${device.tablet} {
    font-size: 20px;
    line-height: 24px;
  }
  @media ${device.widest} {
    ${(props) => props.theme.font.h5};
    font-weight: 400;
    line-height: 31px;
  }
`;

export default translate(Live);
